import { styled } from "@styles";

export const Wrapper = styled("form", {
  ".img-preview": {
    overflow: "hidden",
    width: "100%",
    height: "240px",
  },

  ".image-uploader": {
    display: "none",
  },

  ".uploader-container": {
    marginTop: "30px",
  },

  ".click-drop-button": {
    all: "unset",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",

    width: "100%",
    height: "$500px",

    border: "1px dashed $blue40",
    borderRadius: "$md",

    fontWeight: "$xl",
    fontSize: "$16px",
    color: "$blue90",

    cursor: "pointer",

    ".formats": {
      fontWeight: "$sm",
      fontSize: "$12px",
      color: "$blue90",
    },

    span: {
      color: "$blue40",
      textDecoration: "underline",
    },

    svg: {
      color: "$blue40",
      strokeWidth: "1.5",
    },
  },
});

export const UploaderLabel = styled("label", {
  all: "unset",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  width: "100%",
  height: "$115px",

  border: "1px dashed $blue40",
  borderRadius: "$md",

  fontWeight: "$xl",
  fontSize: "$16px",
  color: "$blue90",

  cursor: "pointer",

  ".formats": {
    fontWeight: "$sm",
    fontSize: "$12px",
    color: "$blue90",
  },

  span: {
    color: "$blue40",
    textDecoration: "underline",
  },

  svg: {
    color: "$blue40",
    strokeWidth: "1.5",
  },
});

export const CropperContainer = styled("div", {
  padding: "10px 0",
  display: "flex",
  flexDirection: "column",

  ".image-uploader": {
    marginTop: "20px",
  },

  ".cropper": {
    border: "1px dashed $blue40",
  },
});

export const PreviewContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  padding: "10px",
  boxSizing: "border-box",
  width: "100%",

  ".img-preview": {
    alignSelf: "center",
  },
});

export const Buttons = styled("div", {
  display: "flex",
  gap: 16,

  ".button": {
    flex: 1,
  },
});

export const ZoomWrapper = styled("div", {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: 10,
  padding: "0 0 $10px 0",
});
